document.addEventListener('DOMContentLoaded', function() {
  // Инициализация табов
  function initTabs() {
    const tabButtons = document.querySelectorAll('[data-tab]');
    const tabSections = document.querySelectorAll('[data-tab-section]');
    
    // Добавляем класс tab-active стартовой секции
    tabSections.forEach(section => {
      if (section.getAttribute('data-tab-section') === 'california') {
        section.classList.add('tab-active');
      }
    });
    
    // Устанавливаем активную кнопку
    setActiveButton('california');
    
    // Добавляем обработчики кликов на кнопки
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        switchTab(targetTab);
      });
    });
  }
  
  // Переключение табов
  function switchTab(targetTab) {
    const tabSections = document.querySelectorAll('[data-tab-section]');
    
    // Убираем активный класс у всех секций
    tabSections.forEach(section => {
      section.classList.remove('tab-active');
    });
    
    // Добавляем активный класс целевой секции
    const targetSection = document.querySelector(`[data-tab-section="${targetTab}"]`);
    if (targetSection) {
      targetSection.classList.add('tab-active');
    }
    
    // Обновляем активные кнопки
    setActiveButton(targetTab);
  }
  
  // Установка активной кнопки
  function setActiveButton(activeTab) {
    const tabButtons = document.querySelectorAll('[data-tab]');
    
    tabButtons.forEach(button => {
      const buttonTab = button.getAttribute('data-tab');
      button.classList.remove('current-tab');
      
      if (buttonTab === activeTab) {
        button.classList.add('current-tab');
      }
    });
  }
  
  // Запускаем инициализацию
  initTabs();
});